import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface GlobalState {
  appVersion: string;
  nativeResult: string;
  products: any[];
}

const initialState: GlobalState = {
  appVersion: '...',
  nativeResult: '',
  products: [
    { productId: "com.mobblo.lib.devapp.p1" }, 
    { productId: "com.mobblo.lib.devapp.p2" }, 
    { productId: "com.mobblo.lib.devapp.p3" }
  ],
};

const globalSlice = createSlice({
  name: 'global',
  initialState,
  reducers: {
    setAppVersion(state, action: PayloadAction<string>) {
      state.appVersion = action.payload;
    },
    setNativeResult(state, action: PayloadAction<string>) {
      state.nativeResult = action.payload;
    },
    setProducts(state, action: PayloadAction<any[]>) {
      state.products = action.payload;
    },
  },
});

export const { setAppVersion, setNativeResult, setProducts } = globalSlice.actions;
export default globalSlice.reducer; 